import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15Z",
		fill: "white",
		stroke: "currentColor",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M24.5 15C24.5 20.2467 20.2467 24.5 15 24.5C9.75329 24.5 5.5 20.2467 5.5 15C5.5 9.75329 9.75329 5.5 15 5.5C20.2467 5.5 24.5 9.75329 24.5 15Z",
		fill: "currentColor",
		stroke: "currentColor"
	})]
});
export default SvgRadioChecked;
